import { __assign } from "tslib";
import * as React from 'react';
import Editor from './Editor';
import { BtnBold, BtnBulletList, BtnClearFormatting, BtnItalic, BtnLink, BtnNumberedList, BtnRedo, BtnStyles, BtnUnderline, BtnUndo, Separator, Toolbar, } from './toolbar';
export default function DefaultEditor(props) {
    return (React.createElement(Editor, __assign({}, props),
        React.createElement(Toolbar, null,
            React.createElement(BtnUndo, null),
            React.createElement(BtnRedo, null),
            React.createElement(Separator, null),
            React.createElement(BtnBold, null),
            React.createElement(BtnItalic, null),
            React.createElement(BtnUnderline, null),
            React.createElement(Separator, null),
            React.createElement(BtnNumberedList, null),
            React.createElement(BtnBulletList, null),
            React.createElement(Separator, null),
            React.createElement(BtnLink, null),
            React.createElement(BtnClearFormatting, null),
            React.createElement(Separator, null),
            React.createElement(BtnStyles, null))));
}
//# sourceMappingURL=DefaultEditor.js.map